import classes from 'components/Dashboards/Reporting/ReportSettingsModal/components/ReportSettingsForm/components/ReportAccessSettings/components/AccessOptionSelection/DescriptionDecorator/DescriptionDecorator.module.scss';

interface Props {
    children: React.ReactNode;
    classNameWrapper?: string;
    description: string;
    isSelected?: boolean;
}

export const DescriptionBelowChildDecorator = ({
    children,
    description,
    classNameWrapper,
    isSelected = false,
}: Props) => {
    return (
        <div className={classNameWrapper}>
            <div className={`${classes.decoratorWrapper} ${isSelected ? classes.currentlySelected : ''} `}>
                <div className={classes.children}>{children}</div>
                <span className={classes.description}>{description}</span>
            </div>
        </div>
    );
};
